const DB_PRODUCTS = [
    {
        id: 101,
        name: "APEX MEN'S FORMAL SHOE",
        sku: "91113A05",
        brand: 33,
        price: 1499,
        color: "#000",
        image: "/assets/images/91113A05_1_2.jpg",
        size: [14, 17],
        description: "Stylish upper gives a sophisticated appeal",
        date: 2020,
        stock: 10,
        rating: 4.5,
        category: 1,
    },
    {
        id: 102,
        name: "VENTURINI MEN'S TOE CAP SHOE",
        sku: "91125A81",
        brand: 31,
        
        price: 4490,
        color: "#d3b48e",
        image: "/assets/images/91125A81_1_2.jpg",
        size: [15],
        description: "SContemporary elongated silhouette gives a refined look",
        date: 2021,
        stock: 10,
        rating: 4.1,
        category: 1,
        featured: false,
    },
    {
        id: 103,
        name: "APEX MEN'S CASUAL SHOE",
        sku: "91117A66",
        brand: 33,
        
        price: 2250,
        color: "#000",
        image: "/assets/images/91120A56_1_1.jpg",
        size: [15],
        description: "SContemporary elongated silhouette gives a refined look",
        date: 2019,
        stock: 10,
        rating: 3.5,
        category: 1,
        featured: false,
    },
    {
        id: 104,
        name: "APEX MEN'S MOCCASIN",
        sku: "91127A06",
        brand: 33,
        
        price: 6990,
        color: "#d3b48e",
        image: "/assets/images/91127A06_1_1.jpg",
        size: [17],
        description: "Contemporary elongated silhouette gives a refined look",
        date: 2020,
        stock: 10,
        rating: 4.7,
        category: 1,
    },
    {
        id: 105,
        name: "APEX MEN'S MOCCASIN",
        sku: "91134A57",
        brand: 33,
        
        price: 7990,
        color: "#77472d",
        image: "/assets/images/91134A57_1_2.jpg",
        size: [11, 13, 15],
        description: "Contemporary elongated silhouette gives a refined look",
        date: 2021,
        stock: 10,
        rating: 3.9,
        category: 1,
    },
    {
        id: 106,
        name: "MAVERICK MEN'S FORMAL SHIRT",
        sku: "09601A08",
        brand: 32,
        price: 1690,
        color: "#d3b48e",
        image: "/assets/images/09601A08_1.jpg",
        size: [11, 13],
        description: "Contemporary elongated silhouette gives a refined look",
        date: 2021,
        stock: 10,
        rating: 2.5,
        category: 1,
    },
    {
        id: 107,
        name: "MAVERICK MEN'S CASUAL SHIRT",
        sku: "09601A08",
        brand: 32,
        
        price: 1690,
        color: "#d3b48e",
        image: "/assets/images/09601A08_1.jpg",
        size: [11, 13],
        description: "Contemporary elongated silhouette gives a refined look",
        date: 2021,
        stock: 10,
        rating: 1.5,
        category: 1,
    },
    {
        id: 108,
        name: "MAVERICK MEN'S CASUAL SHIRT",
        sku: "09601A09",
        brand: 32,
        
        price: 2450,
        color: "#0100ff",
        image: "/assets/images/09601A09_1.jpg",
        size: [15],
        description: "Contemporary elongated silhouette gives a refined look",
        date: 2021,
        stock: 10,
        rating: 3.5,
        category: 1,
        featured: true,
    },
    {
        id: 109,
        name: "MAVERICK MEN'S FORMAL SHIRT",
        sku: "09602A42",
        brand: 32,
        
        price: 1690,
        color: "#d3b48e",
        image: "/assets/images/09602A42_1.jpg",
        size: [11, 13],
        description: "Contemporary elongated silhouette gives a refined look",
        date: 2019,
        stock: 10,
        rating: 5.0,
        category: 1,
        featured: true,
    },
    {
        id: 110,
        name: "BATA RED LABEL NANA Block Heel Sandal",
        sku: "7715557",
        brand: 34,
        
        price: 2429.00,
        color: "#ffc0cb",
        image: "/assets/images/7715557.png",
        size: [15],
        description: "Heading out for a romantic meal with your beau, or got a wild night out with girls planned? You’ll be turning heads whatever the occasion with our smokin’ selection of Bata Red Label heeled sandals, the perfect addition to any outfit.",
        date: 2019,
        stock: 10,
        rating: 5.0,
        category: 2,
        featured: true,
    },
    {
        id: 111,
        name: "BATA RED LABEL GARLA Pointy-Toe Pump Shoe For Women",
        sku: "6515541",
        brand: 34,
        price: 2969.00,
        color: "#ffc0cb",
        image: "/assets/images/6515541.png",
        size: [16],
        description: "Prep your posh look with a classic style & classic comfort. Get in a sunny state of mind with these pointed-toe stylish flat pump shoes with a trendy square-shaped heel for the ladies. These slip-ons are perfect for boat side to streetside & dates, events & more. Keep your outfit sharp in fashion-forward shoes, like these!",
        date: 2019,
        stock: 10,
        rating: 5.0,
        category: 2,
        featured: true,
    },
    {
        id: 112,
        name: "Batman Sneaker For Kids By Justice League",
        sku: "3216996",
        brand: 34,
        
        price: 1799.00,
        color: "#000",
        image: "/assets/images/3216996.png",
        size: [11, 13],
        description: "Bata just launched an exclusive Justice League collection in collaboration with Warner Media featuring the Justice League characters, logos, artworks, and designs on Bata shoes for kids. Bata is the only official footwear brand in the country authorized to launch this Justice League collection and has created these exclusive lines of merchandise. So, here goes a super-cool Batman-themed sneaker that features an anti-bacterial material, a lightweight phylon outsole, an amazingly comforting footbed made with EVA, breathable mesh upper & altogether that ensures long-lasting freshness & ultimate comfort.",
        date: 2019,
        stock: 10,
        rating: 5.0,
        category: 3,
        featured: true,
    },
    {
        id: 113,
        name: "Bubble Gummers' TOUGH High-Top Shoe",
        sku: "3214970",
        brand: 34,
        price: 1799.00,
        color: "#a58b2a",
        image: "/assets/images/3214970.png",
        size: [11, 13],
        description: "This high-top shoes in soft & durable PU, our boys' shoes are ready for any adventure. Covering all their needs, from functional through to fun, these shoes for boys are lightweight ensuring they can spend all day in comfort & style.",
        date: 2019,
        stock: 10,
        rating: 5.0,
        category: 3,
        featured: true,
    },
];

export default DB_PRODUCTS;